import { render, staticRenderFns } from "./FerramentasItem.vue?vue&type=template&id=0b90c4f4&"
import script from "./FerramentasItem.vue?vue&type=script&lang=js&"
export * from "./FerramentasItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports